import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Button } from "antd";

import { loginLog } from "../../utils/useUser";

const ProductPuchaseComponent = ({ item }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	const [imgSrc, setImgSrc] = useState("/assets/images/no-product.png");

	useEffect(() => {
		if (item?.target_id) {
			setImgSrc(
				`${process.env.REACT_APP_CDN}/image/recommend/${item?.target_id}.jpg`
			);
		} else if (reduxChannel?.influencer_id) {
			setImgSrc(
				`${process.env.REACT_APP_CDN}/image/together/${reduxChannel?.influencer_id}/${item?.id}.${item?.img_type}`
			);
		}
	}, [item, reduxChannel]);

	const handleCopyLink = (e) => {
		window.navigator.clipboard.writeText(e.currentTarget.value).then(() => {
			alert("코드 복사가 완료 되었습니다.");
		});
	};

	const productClickLog = (link) => {
		let query = `together-products-${reduxChannel?.user_id}-${link?.product_id}`;
		loginLog({ id: reduxChannel?.user_id }, query);
	};

	return (
		<div className={`product-recommend-each`}>
			{item?.is_best && <p className={`product-best`}>BEST</p>}
			<div className={`product-image-div`}>
				<img
					src={imgSrc?.length ? imgSrc : "/assets/images/no-product.png"}
					onError={({ currentTarget }) => {
						currentTarget.onerror = null; // prevents looping
						// currentTarget.style.display = "none";
						currentTarget.src = `/assets/images/no-product.png`;
					}}
					alt={`영양제 이미지`}
					// className={`product-recommend-image`}
					placeholder={`/assets/images/no-product.png`}
				/>
			</div>
			<div className={`product-description`}>
				<div className={`product-name-div`}>
					<p className={`product-category-name`}>{item?.category_name}</p>
					<p className={`product-brand-name`}>{item?.brand_name}</p>
					<p className={`product-name`}>{item?.product_name}</p>
				</div>
				<div className={`product-name-div padding-top`}>
					<p className={`product-sub`}>{item?.sub_title}</p>
					<div className={`product-list`}>
						{Array.from({ length: 6 }).map((arr, idx) => {
							let column = `description` + (idx + 1);
							if (item[column]) {
								return (
									<div className={`product-list-each`} key={`상품 설명 ${idx}`}>
										<p className={`list-num`}>0{idx + 1}</p>
										<p>{item[column]}</p>
									</div>
								);
							}
						})}
					</div>
				</div>

				{item?.purchaseLinkList?.map((item, idx) => (
					<div
						key={`구매 링크 할인 코드 ${idx}`}
						className={`discount-code-wrap`}
					>
						{item?.discount_code && (
							<div className={`product-discount-code-wrap`}>
								{item?.platform_id === 3 ? (
									<p>{item?.platform_name} 가입 코드</p>
								) : (
									<p>{item?.platform_name} 할인 코드</p>
								)}
								<div className={`discount-code-div`}>
									<div className={`discount-code`}>
										<span>{item.discount_code}</span>
									</div>
									<Button
										className={`discount-copy`}
										value={item.discount_code}
										onClick={handleCopyLink}
									>
										<img
											src={`/assets/images/channel/link-copy.png`}
											alt={`링크 생성`}
											height={12}
										/>
										코드복사
									</Button>
								</div>
							</div>
						)}
					</div>
				))}
				{item?.purchaseLinkList?.length > 0 ? (
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "0.5em",
							marginTop: "1em",
						}}
					>
						{item?.purchaseLinkList?.map((link, idx) => (
							<div key={`구매 링크 ${idx}`}>
								{link?.url && (
									<button
										className={`product-purchase`}
										style={{ width: "100%" }}
										onClick={() => {
											productClickLog(link);
											window.open(link?.url);
										}}
									>
										{link.platform_name === "당신의 영양제"
											? ""
											: `${link.platform_name} `}
										구매하기
									</button>
								)}
							</div>
						))}
					</div>
				) : (
					<button
						className={`product-purchase gray`}
						style={{ width: "100%", marginTop: "auto" }}
					>
						약국에서 구매가 가능한 상품입니다.
					</button>
				)}
			</div>
		</div>
	);
};
export default ProductPuchaseComponent;
